module.exports = __webpack_public_path__ + "img/password-white-icon.ef120a63.svg";